<div class="form-group fg-field" [class.has-error]="required && fieldValid == 0">
  <label [attr.for]="fieldId">
    {{ name }} <sup *ngIf="required">*</sup>
    <i class="ti-reload fa fa-spin" *ngIf="loading"></i>
  </label>

  <div class="fg-control">
    <span class="fg-control__icon" *ngIf="icon"><i [class]="icon"></i></span>

    <mat-select [id]="fieldId" class="fg-select" [(ngModel)]="value" (valueChange)="valueChanged($event); validate()">
      <mat-select-trigger>
        <span>{{ selectedLabel }}</span>
      </mat-select-trigger>
      <mat-option *ngIf="!noEmptyValue" [value]="isObject ? null : -1">{{ placeholder }}</mat-option>

      <ng-template ngFor let-item let-i="index" [ngForOf]="options">
        <mat-option *ngIf="(skipBlankItems && item != null && item.length) || !skipBlankItems" [value]="isObject ? item : i">
          {{ isObject ? item[objectNameField] : item }}
        </mat-option>
      </ng-template>
    </mat-select>
  </div>

  <span class="help-block animated fadeIn">
    <strong class="text-default" [class.text-danger]="required && fieldValid == 0">
      <small *ngIf="required && fieldValid == 0; else showHelpText">Select an item for {{ name }}</small>
      <ng-template #showHelpText>
        <small>{{ helpText || '&nbsp;' }}</small>
      </ng-template>
    </strong>
  </span>
</div>
